import React from 'react';
import RetentionCriteria from './RetentionCriteria';
import RetentionConditions from './RetentionConditions';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import {
  retentionBuilderCriteriaTooltip,
  retentionBuilderEventsTooltip,
} from '../../../../components/KubitTooltip/globalTooltips';
import SectionHeading from '../../../../components/SectionHeading';
import ReportFilter from '../../../../components/Builder/ReportFilter';
import Breakdown from '../../../../components/Builder/Breakdown';
import ExecuteReport from '../../../../components/Builder/ExecuteReport';
import { IRowMeta, RowType } from '../../../../redux/slices/oldBuilder';
import RetentionBuilderHeader from './RetentionBuilderHeader';
import useShowCloseLlmPrompt from '../../../../components/Builder/LlmPrompt/useShowCloseLlmPrompt';
import LlmPrompt from '../../../../components/Builder/LlmPrompt';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';

const startingRowMeta: IRowMeta = {
  rowType: RowType.retention,
  rowIndex: 0,
};
const returningRowMeta: IRowMeta = {
  rowType: RowType.retention,
  rowIndex: 1,
};

const RetentionBuilder = () => {
  const { showLlmPrompt, handleCloseLlmPrompt } = useShowCloseLlmPrompt();

  return (
    <>
      <RetentionBuilderHeader />
      {showLlmPrompt && (
        <LlmPrompt
          queryType={QueryType.Retention}
          onClose={handleCloseLlmPrompt}
        />
      )}
      <BuilderUI.Part1>
        <SectionHeading
          heading="Retention Criteria"
          tooltipOption={retentionBuilderCriteriaTooltip}
        />
        <RetentionCriteria />
        <BuilderUI.HorizontalDivider />
        <SectionHeading
          heading="Event(s)"
          tooltipOption={retentionBuilderEventsTooltip}
        />
        <RetentionConditions
          rowMeta={startingRowMeta}
          label={'Starting Event(s)'}
        />
        <RetentionConditions
          rowMeta={returningRowMeta}
          label={'Returning Event(s)'}
        />
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        <ReportFilter />
        <BuilderUI.HorizontalDivider />
        <Breakdown />
      </BuilderUI.Part2>
      <ExecuteReport />
    </>
  );
};

export default RetentionBuilder;
